import script from "./MisSolicitudes.vue?vue&type=script&setup=true&lang=js"
export * from "./MisSolicitudes.vue?vue&type=script&setup=true&lang=js"

import "./MisSolicitudes.vue?vue&type=style&index=0&id=c3881796&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3881796"]])

export default __exports__